export enum ServiceMeterTypeEnum {
  FROM = "from",
  TO = "to",
}
export enum SubmitTypeEnum {
  PAYNOW,
  ADD_TO_CART,
  DECLARE,
}

export enum ServiceParameterEnum {
  AMT = "AMT",
  CUSNO = "CUSNO",
  CID = "CID",
  A1 = "A1",
  CNFR1 = "CNFR1",
  SKOLA_PERMOKA = "SKOLA_PERMOKA",
}

export enum ParamLabelEnum {
  TARIFF = "tarifas",
}

export enum ParameterTypeEnum {
  CURRENCY = "currency",
  INTEGER = "integer",
  FLOAT = "float",
  INTEGER_WITH_ZERO = "integer_with_zero",
  IBAN = "iban",
  LIST = "list",
  DATE = "date",
  STRING = "string",
}

export enum AmountCalculationEnum {
  UNCALCULABLE = 0,
  CALCULABLE = 1,
}

export enum ServiceCategoryIdEnum {
  ELECTRICITY = 1,
  GAS = 2,
  WATER = 3,
  HEAT = 4,
  HOUSE_CARE = 5,
  TELECOMMUNICATIONS = 6,
  FINANCIAL_SERVICES = 7,
  SECURITY = 8,
  EDUCATION = 9,
  DIRECT_PAYMENT = 10,
  FISHING = 11,
  INVOICES = 12,
  OTHER = 13,
  GARBAGE = 14,
  GSM_VOUCHERS = 15,
}

export interface IService {
  id: string;
  keywords: string;
  category_id: ServiceCategoryIdEnum;
  api_service_name: string;
  amt_calculation: AmountCalculationEnum;
  group: string | null;
  parameters?: Array<IServiceParameter>;
  import_date?: string;
  commission?: string;
  one_time?: OneTimeEnum;
  data_declaration: boolean;
}

export enum OneTimeEnum {
  FALSE = 0,
  TRUE = 1,
}

export interface IServiceParameter {
  hidden: boolean;
  group_label: string | null;
  meter_type: ServiceMeterTypeEnum;
  read_only: boolean;
  api_parameter_label: string;
  service_parameter_id: number;
  parameter_name: ServiceParameterEnum;
  parameter_type: ParameterTypeEnum;
  two_in_row: boolean;
  value: string;
  step: number;
  dropdown_items?: Array<{
    item_identifier: string;
    item_description: string;
  }>;
}

export interface IGetUpdateServiceInformationPayload {
  service_id: string;
  service_parameters: Array<string>;
  values: Array<string>;
}

export interface IFindServiceProviderPayload {
  keywords: string;
}

export interface IServiceGroup {
  type: "services";
  id: string;
  category_id: number;
  api_service_name: string;
}
export interface ICalculateAmountResponse {
  meta: {
    success: boolean;
    message: string;
    data: {
      AMT: number;
    };
  };
}

export interface ICalculateAmountPayload {
  service_id: string;
  params: {
    [index: string]: string;
  };
}
